import StatusChip from "@entrilia/shared/components/StatusChip";
import type { AssistantTask } from "../../../../api/types/assistantTypes";

interface Props {
  task: AssistantTask;
  kind: "outcome" | "state";
  height?: "smaller";
}

const TaskStatusChip = ({ task, kind, height }: Props) => {
  if (task.isRunning) {
    return <StatusChip label="Running" color={(t) => t.palette.info.main} height={height} />;
  }

  switch (task.attentionReason) {
    case "PausedNoAccess":
    case "PausedFailures":
      return <StatusChip label="Paused" color={(t) => t.palette.error.main} height={height} />;
    case "LastRunFailed":
      return <StatusChip label="Failed" color={(t) => t.palette.error.main} height={height} />;
    case "Skipped":
      return <StatusChip label="Skipped" color={(t) => t.palette.warning.main} height={height} />;
  }

  if (task.status === "Paused") {
    return <StatusChip label="Paused" color={(t) => t.palette.text.secondary} neutral height={height} />;
  }

  if (kind === "outcome") {
    return <StatusChip label="Done" color={(t) => t.palette.success.main} height={height} />;
  }

  return task.status === "Active" ? (
    <StatusChip label="Active" color={(t) => t.palette.success.main} height={height} />
  ) : (
    <StatusChip label="Finished" color={(t) => t.palette.text.secondary} neutral height={height} />
  );
};

export default TaskStatusChip;
